import { type CSSProperties } from 'react';
import type { AvatarShapePart } from '@/shared/features/user-avatar';
import { cn } from '@/utils';
export const AvatarColorPicker = ({
  colors,
  selectedColorIndex,
  onSelect
}: {
  colors: AvatarShapePart[];
  selectedColorIndex: number;
  onSelect: (index: number) => void;
}) => {
  return <div className="flex w-full gap-xs overflow-x-auto p-sm" data-sentry-component="AvatarColorPicker" data-sentry-source-file="AvatarColorPicker.tsx">
      {colors.map((part, index) => {
      const isActive = selectedColorIndex === index;
      const noColor = part.hex === null;
      return <div key={part.partId} onClick={() => onSelect(index)} style={{
        '--item-color': part.hex ?? '#CCCCCC'
      } as CSSProperties} className={cn('h-[20px] min-w-[20px] cursor-pointer rounded-full border border-black/10', !noColor && 'bg-[var(--item-color)]', noColor && 'bg-[repeating-linear-gradient(45deg,theme(colors.gray.100)_0,theme(colors.gray.100)_4px,#fff_4px,#fff_8px)]', isActive && 'shadow-[0_0_0_1px_#fff,0_0_0_3px_theme(colors.violet.500)]')} />;
    })}
    </div>;
};